import { CredentialApplicationDefinitionType } from 'src/app/shared/models/credential/CredentialApplicationDefinitionType';
import { ScenarioRequirementDefinition } from 'src/app/shared/models/credential/scenarioRequirementDefinition.model';

export class ScenarioDefinitionModel {
  id: string;
  name: string;
  description: string;
  credentialDefinitionName: string;
  credentialDefinitionId: string;
  type: CredentialApplicationDefinitionType;
  status: ScenarioDefinitionStatus;
  createdBy: string;
  updatedBy: string;
  createdOn: Date;
  updatedOn: Date;
  requirements: ScenarioRequirementDefinition[] = [];

  constructor(data?: ScenarioDefinitionModel) {
    if (!data) return;
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.credentialDefinitionName = data.credentialDefinitionName;
    this.credentialDefinitionId = data.credentialDefinitionId;
    this.status = data.status;
    this.type = data.type;
    this.createdBy = data.createdBy;
    this.updatedBy = data.updatedBy;
    this.createdOn = data.createdOn;
    this.updatedOn = data.updatedOn;
    this.requirements = data.requirements?.length
      ? data.requirements.map((r) => ScenarioRequirementDefinition.parse(r))
      : [];
  }

  markAsActive() {
    this.status = ScenarioDefinitionStatus.Active;
  }

  markAsInactive() {
    this.status = ScenarioDefinitionStatus.Inactive;
  }

  get isActive() {
    return this.status === ScenarioDefinitionStatus.Active;
  }
}

export enum ScenarioDefinitionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}
